import { ContentBox } from "@msuite/ui/app-shell";
import { OrdersTable } from "@/components/stock/orders-table";

/**
 * The warehouse's order list: every order of the organisation, whoever placed it and whichever
 * site it stands on. The personal list, narrowed to the caller's own sites, is `sites/orders`.
 */
export function Orders() {
	return (
		<ContentBox>
			<OrdersTable persistenceKey="data-orders-table" />
		</ContentBox>
	);
}
